export default class extends HTMLElement {
  constructor() {
    super();
    console.log('Init DSBVideo');
    this.video = {};
    this.hooks = {};
    this.audio_meta=false;
    this.delegate=false;
    this.loaderElement=null;
    this.backgroundElement=null;
    this.usingGlobalObject=false;
    this.allowDestructor = true;
    this.registeredListners=[];
    this.event_data={};
    this.player = false;
    this._src={};
    this.selected_src={};
  }

  disconnectedCallback()
  {
    this._log('debug','disconnectedCallback','Init');
    if(this.allowDestructor)
    {
      this._log('debug','disconnectedCallback','Resetting');
      this.action('reset');
    }

    for(let i=0;i<this.registeredListners.length;i++)
    {
      try
      {
        if('type' in this.registeredListners[i] && 'object' in this.registeredListners[i])
        {
          switch(this.registeredListners[i].type)
          {
            case "IntersectionObserver":
              if('disconnect' in this.registeredListners[i].object)
              {
                this.registeredListners[i].object.disconnect();
              }
              else
              {
                this._log('warning','disconnectedCallback','Cannot disconnect',this.registeredListners[i]);
              }
              break;
            default:
                this._log('warning','disconnectedCallback','Dunno what to do with '+this.registeredListners[i].type,this.registeredListners[i]);
              break;
          }
        }
      }
      catch(ex)
      {
        this._log('error','disconnectedCallback','Fatal error',ex,this.registeredListners[i]);
      }

    }
  }

  setDestructor(value)
  {
    this.allowDestructor=value;
  }

  resetSrc(force=false)
  {
    this.selected_src={};
  }

  set src(newValue){
      this._src=newValue;
      this.selectSRC();
  }

  get src()
  {
    return this._src;
  }

  selectSRC()
  {
    try
    {
      if(this.selected_src && !(typeof this.selected_src === 'object') || !('url' in this.selected_src))
      {
        this.selected_src={};
        let _src = this.src;
        if(typeof _src === 'object')
        {
          let closest_width={};
          let current_width=parseInt(this.offsetWidth);

          for(let video in _src)
          {
            if('url' in _src[video])
            {
              if('width' in _src[video])
              {
                closest_width[current_width-parseInt(_src[video].width)]=_src[video];
              }
            }
          }
          let _closest_width=(Object.keys(closest_width).reduce((accumulator, currentValue) => {
              if(currentValue>0)
              {
                accumulator[currentValue] = closest_width[currentValue];
              }
              return accumulator;
          }, {}));

          if(typeof _closest_width === 'object' && Object.keys(_closest_width).length ==0)
          {
            this.selected_src=closest_width[Object.keys(closest_width)[Object.keys(closest_width).length-1]];
          }
          else
          {
            this.selected_src=_closest_width[Object.keys(_closest_width)[0]];
          }
          this._log('debug','selectSRC','Selected video',this.selected_src,closest_width,_closest_width);
        }
        else
        {
          this.selected_src.url=_src;
        }

        this.selected_src.type= 'video/'+this.selected_src.url.split('.').slice(-1)[0];
      }
      return this.selected_src;
    }
    catch(ex)
    {
      this._log('error','selectSRC',ex);
      this.selected_src=false;
    }
  }

  get settings() {
      if(!this._settings)
      {
          if(typeof this.getAttribute('settings') === 'object' && this.getAttribute('settings') !== null)
          {
              this._settings = this.getAttribute('settings');
          }
          else
          {
            this._settings = JSON.parse(``+this.getAttribute('settings')+``);
          }

          if(this._settings == null)
          {
              this._settings = {};
          }
      }
      return this._settings;
  }

  set settings(newValue){
      if(typeof newValue === 'object' && newValue !== null)
      {
        this._settings = newValue;
      }
      else
      {
          this.setAttribute('settings', newValue);
      }
  }

  setHooks(hooks)
  {
    this.hooks=hooks;
  }

  setDelegateElement(delegate)
  {
    this.delegate=delegate;
  }

  _log(type,source,message,data='')
  {
    let _message = 'dsb-app/DSBVideo('+this.selectSRC.url+')::'+source+'- '+message;
    switch(type)
    {
       case "debug":
         console.debug(_message,data);
        break;
      case "warning":
         console.warn(_message,data);
        break;
      case "error":
         console.error(_message,data);
        break;
      default:
          console.log(_message,data);
    }
  }

  canPlay()
  {
    try
    {
      if(this.selected_src==false)
      {
        return false;
      }
      let test = document.createElement("video");
      let canPlay = test.canPlayType(this.selected_src.type);
      this._log('debug','canPlay','Checking for playback of '+this.selected_src.type,canPlay);
      if(canPlay=="")
      {
        return false;
      }
      else
      {
        return canPlay;
      }
    }
    catch(ex)
    {
      return true;
    }
  }

  async hasVideo()
  {
    if(!('available' in this.video))
    {
      try
      {
        let _this = this;
        this.video.available=false;
        if(!this.selected_src)
        {
          return false;
        }
        let available = await new Promise(function (resolve, reject) {
          let request = new XMLHttpRequest();
          request.open("HEAD",_this.selected_src.url , true);
          request.onload = () => {
            if (request.status == 201 || request.status == 200) {
                resolve(true);
            } else {
                reject(false);
            }
          };
          request.onerror = function () {
              reject(false);
          };
          request.send();
        })
        .then(function(response) {
          return response;
        })
        .catch(function(err) {
          return err;
        });
        if(typeof available === 'boolean')
        {
          this.video.available = available;
        }
      }
      catch(ex)
      {
        this._log('error','hasVideo','Problem checking video',ex);
        // TODO check online
      }
    }
    this._log('debug','hasVideo',this.video.available);
    return this.video.available;
  }

  async action(value,callback=false)
  {
    if(this.selected_src)
    {
      let _this = this;
      let _url = this.selected_src.url;
      let _url_format = this.selected_src.type;
      let app = window.fw_workbench.getApp();

      let function__destroyVideoObject = async function(){
        let video = false;
        if(typeof app == 'object' && 'getGlobalObject' in app)
        {
          let object_id = 'play';
          let object_type='video';

          video = await app.getGlobalObject(object_type,object_id);
          video.stop();

          if(video)
          {
            await app.removeGlobalObject(object_type,object_id);
          }
        }
        else
        {
          if(typeof _this.video == 'object' && 'source' in _this.video)
          {
            _this.video.stop()
            _this.video={};
          }
        }
        return;
      }
      let function__initVideoObject = async function(){
        if(typeof _this.video !== 'object' || !('state' in _this.video))
        {
          _this.video = {};
          _this.video.state='none';
          _this.video.addedToGlobal=false;
          _this.video.element = document.createElement("video");
          _this.video.element.setAttribute('playsinline','playsinline');

          if(('id' in _this.settings) && _this.settings.id.length > 0)
          {
            _this.video.element.id=_this.settings.id;
          }
          _this.video.element.preload='auto';
          _this.video.element.type=_url_format;
          _this.video.element.src=_url+'#t=0.1';
          _this.video.element.style="width: var(--fwwb-coverflow-width);transform: translate(-50%, -50%);position: absolute;top: 50%;left: 50%;";

          _this.video.resize = async function()
          {
            if('height' in _this.selected_src)
            {
              let width_scaled_ratio=((_this.offsetWidth/_this.selected_src.width));
              let height_scaled=(_this.selected_src.height*width_scaled_ratio);
              let hidden_height = height_scaled-_this.offsetHeight;
              let height_scaled_percent =(height_scaled/_this.offsetHeight)*100;

              if(height_scaled_percent>150 || height_scaled_percent<100)
              {
                _this.video.element.style.width='auto';
                _this.video.element.style.maxHeight=_this.offsetHeight+'px';
              }
              else
              {
                _this.video.element.style.width='100%';
              }
            }
          }
          _this.video.resize();
          //_this.addEventListener("resize", function__resizeVideo);


          if('onclick' in _this.settings)
          {
            if(_this.settings.onclick=='delegate_click' && _this.delegate instanceof HTMLElement)
            {
              _this.video.element.onclick = _this.delegate.onclick;
              _this.video.element.dblclick = _this.delegate.dblclick;
            }
          }

          _this.video.duration=false;

          if('ontimeupdate' in _this.settings)
          {
            if(typeof _this.settings.ontimeupdate === 'function')
            {
              _this.video.element.ontimeupdate  = function(){
                _this.settings.ontimeupdate(_this.video);
              };
            }
          }

          if(('onplay' in _this.settings) && typeof _this.settings.onplay  === 'function')
          {
              _this.video.element.onplay  = function(){
                _this.settings.onplay(_this.video);
              };
          }

          _this.video.element.loadedmetadata = function(){
             if(_this.loaderElement instanceof HTMLElement)
             {
                _this.loaderElement.remove();
             }
          };
          _this.video.element.loadeddata = function(){
            if(_this.loaderElement instanceof HTMLElement)
             {
                _this.loaderElement.remove();
             }
          };

           _this.video.element.oncanplay = function(){
            if(_this.loaderElement instanceof HTMLElement)
             {
                _this.loaderElement.remove();
             }
          };

           _this.video.element.onended = function(){
               _this.video.state='stopped';
              if(typeof _this.hooks.onComplete === 'function')
              {
                _this.hooks.onComplete(_this.video.element);
              }
              if(('onended' in _this.settings) && typeof _this.settings.onended === 'function')
              {
                _this.settings.onended(_this.video.element);
              }
          };

          if(_this.backgroundElement instanceof HTMLElement)
          {
            _this.backgroundElement.after(_this.video.element);
          }
          else
          {
            _this.prepend(_this.video.element);
          }
          _this.video.isRunning = async function(){
            let _return =false;
            if(_this.video.element instanceof HTMLMediaElement)
            {

            }
            return _return;
          };
          _this.video.resume = async function(){
            if(_this.video.element instanceof HTMLMediaElement)
            {
              let shouldPlay=false;
              if(_this.video.state=='paused')
              {
                shouldPlay=true;
              }
              if(('useLastPlayerState' in _this.settings) && _this.settings.useLastPlayerState === true)
              {
                if(typeof app == 'object' && 'getGlobalObject' in app)
                {
                  let existing = app.getGlobalObject('video','play');
                  let lastPlayerState=false;
                  if(typeof existing == 'object' && 'state' in existing)
                  {
                    lastPlayerState=existing.state;
                  }
                  if(lastPlayerState)
                  {
                    if(lastPlayerState=='paused')
                    {
                      shouldPlay=true;
                    }
                    else
                    {
                      shouldPlay=false;
                    }
                    _this._log('debug','action.function__initVideo','Setting video to last player state ('+lastPlayerState+')', _this.video);
                  }
                }
              }
              if('mode' in _this.settings && typeof _this.settings.mode === 'object' && 'autoplayback' in _this.settings.mode)
              {
                if(_this.settings.mode.autoplayback!=='play')
                {
                  shouldPlay=false;
                }
                else if(_this.video.state=='none')
                {
                  shouldPlay=true;
                }
              }
              if(shouldPlay)
              {
                if('onResume' in _this.hooks && typeof _this.hooks.onResume === 'function')
                {
                  _this.hooks.onResume();
                  _this.video.play(true);
                }
                else
                {
                  _this.video.play();
                }
              }
            }
          };
          _this.video.play = async function(noHooks=false){
            if(_this.video.element instanceof HTMLMediaElement)
            {
              if(('prePlay' in _this.settings) && typeof _this.settings.prePlay  === 'function')
              {
                  _this.settings.prePlay(_this.video);
              }
              if(!_this.video.addedToGlobal && typeof app == 'object' && 'getGlobalObject' in app)
              {

                await app.setGlobalObject('video','play',_this.video,async function(object){
                  if(typeof object === 'object' && 'halt' in object && typeof object.halt == 'function')
                  {
                    object.halt();
                  }
                });
                _this.video.addedToGlobal=true;
                _this._log('debug','action.function__initVideo','Video registered with app.GlobalObject', _this.video);
              }
              else
              {
                _this._log('debug','action.function__initVideo','Already registered with app.GlobalObject... skip....', _this.video);
              }

              try
              {
                await _this.video.element.play();
                _this.video.state='playing';
                if('mode' in _this.settings && typeof _this.settings.mode === 'object' && 'autoplayback' in _this.settings.mode)
                {
                  _this.settings.mode.autoplayback='play';
                }
                _this._log('debug','action.video.play',_this.video.state);
                if(!noHooks && 'onPlay' in _this.hooks && typeof _this.hooks.onPlay === 'function')
                {
                  _this.hooks.onPlay();
                }
              }
              catch(ex)
              {
                _this._log('error','action.video.play',ex);
                //alert('Error play (play event)'+ex);
              }
            }
          };
          _this.video.pause = async function(type='default'){
            if(_this.video.element instanceof HTMLMediaElement)
            {
              if(('prePause' in _this.settings) && typeof _this.settings.prePause  === 'function')
              {
                  _this.settings.prePause(_this.video);
              }
              _this.video.element.pause();
              if('mode' in _this.settings && typeof _this.settings.mode === 'object' && 'autoplayback' in _this.settings.mode)
              {
                _this.settings.mode.autoplayback='paused';
              }
              _this.video.state='paused';
              _this._log('debug','action.video.pause',_this.video.state);
              if(type=='focuslost' && 'onFocusLost' in _this.hooks && typeof _this.hooks.onFocusLost === 'function')
              {
                _this.hooks.onFocusLost();
              }
              else
              {
                if('onPause' in _this.hooks && typeof _this.hooks.onPause === 'function')
                {
                  _this.hooks.onPause();
                }
              }
            }
          };
          _this.video.stop = async function(){
            if(_this.video.element instanceof HTMLMediaElement)
            {
              if(('preStop' in _this.settings) && typeof _this.settings.preStop  === 'function')
              {
                  _this.settings.preStop(_this.video);
              }
              _this.video.element.pause();
              _this.video.element.currentTime = 0;
              _this.video.state='stopped';
              _this._log('debug','action.video.stop',_this.video.state);
              if('onStop' in _this.hooks && typeof _this.hooks.onStop === 'function')
              {
                _this.hooks.onStop();
              }
            }
          };
          _this.video.halt = async function(){
            if(_this.video.element instanceof HTMLMediaElement)
            {
              _this.video.element.pause();
              _this.video.addedToGlobal=false;
              if('onHalt' in _this.hooks && typeof _this.hooks.onHalt === 'function')
              {
                _this.hooks.onHalt();
              }
            }
          };
          if(typeof _this.hooks.onLoading === 'function')
          {
            _this.hooks.onLoading(_this.video.element);
          }
          if(('auto' in _this.settings) && _this.settings.autoplay === 'play')
          {
            //_this.video.element.setAttribute('autoplay','autoplay');
            _this.video.play();
          }
          _this._log('debug','action.function__initVideo','Video created and appended', _this.video);
        }
        else
        {
          _this._log('debug','action.function__initVideo','Already has a video setup... skip....', _this.video);
        }
      }


      try
      {
        this._log('debug','action','Running', value);
        await function__initVideoObject();
        switch(value)
        {
          case "reset":
            return await function__destroyVideoObject(callback);
          case "isRunning":
            if(_this.video.state === "playing")
            {
              return true;
            }
            return false;
          case "resume":
            return await this.video.resume();
          case "stop":
            return await this.video.stop();
          case "focuslost":
            return await this.video.pause('focuslost');
          case "pause":
            return await this.video.pause();
          case "play":
            return await this.video.play();
          case "resize":
            return await this.video.resize();
          default:
            break;
        }
      }
      catch(ex)
      {
        throw ex;
      }
    }
    return false;
  }

  async connectedCallback() {
    let copy = this.innerHTML;
    let _this = this;
    if('backgroundimage' in _this.settings)
    {
      this.backgroundElement = document.createElement("div");
      this.backgroundElement.style='width: var(--fwwb-coverflow-width);height: calc(var(--fullheight) - var(--fwwb-header-height) - var(--fwwb-nav-bottom) - var(--other-elements-height));position: absolute;top:0px;left:0px;background-image:url('+_this.settings.backgroundimage+');background-size: auto 100%;background-position: top;filter: blur(8px);-webkit-filter: blur(8px);-ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter: alpha(opacity=30);-moz-opacity: 0.3;-khtml-opacity: 0.3;opacity: 0.3;';
      this.append(this.backgroundElement);
    }

    if(await this.hasVideo())
    {
      this._log('debug','connectedCallback','Setting up video elements...', this.settings);
      this.style='position: relative;display: inline-block;width:100%;height:100%;min-width:100%;min-height:100%;';

      let videoComponentScrollObserver = new IntersectionObserver(async function(entries, observer) {
        entries.forEach(async function(entry) {
            let toTop = false;
            const currentY = entry.boundingClientRect.y;
            const currentRatio = entry.intersectionRatio;


             console.error('videoComponentScrollObserver',_this.settings.mode);

            if (entry.isIntersecting == 0)
            {
              _this._log('debug','connectedCallback.videoComponentScrollObserver','Leaving video...');
              if(typeof _this.video === 'object' && 'state' in _this.video &&  _this.video.state=='playing')
              {
                _this._log('debug','connectedCallback.videoComponentScrollObserver','Focus lost on video');
                if('onfocuslost' in _this.settings && typeof _this.settings.onfocuslost === 'function')
                {
                  await _this.settings.onfocuslost();
                }
                else
                {
                  await _this.action('focuslost');
                }
                if('mode' in _this.settings && typeof _this.settings.mode === 'object' && 'autoplayback' in _this.settings.mode)
                {
                  _this.settings.mode.autoplayback='play';
                }
              }
            }
            else
            {
                if(typeof _this.video === 'object' && 'state' in _this.video)
                {
                  _this._log('debug','connectedCallback.videoComponentScrollObserver','Resuming video...');
                  await _this.action('resume');
                }
                else
                {
                  _this._log('debug','connectedCallback.videoComponentScrollObserver','Not in paused state so let the user decide.');
                }
            }
        });
      },{threshold:0.25});

      videoComponentScrollObserver.observe(this);
      this.registeredListners.push({'type':'IntersectionObserver','object':videoComponentScrollObserver});

      this.loaderElement = document.createElement("maa-spinner");
      this.loaderElement.style="position: absolute;width:100%;"
      this.append(this.loaderElement);

      if(!(this.delegate instanceof HTMLElement))
      {
        this.delegate = document.createElement("span");
        this.delegate.style="position: absolute;top:20%;left:50%;transform: translate(-50%, 0);text-align: center;padding:5px;font-weight:55px;font-size:calc(var(--fwwb-coverflow-width)/3);color:white;-ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter: alpha(opacity=60);-moz-opacity: 0.6;-khtml-opacity: 0.6;opacity: 0.6;"
        this.delegate.classList='icon-clickable icon-play-circle-fill';
        this.delegate.innerHTML='';
        this.delegate.onclick = async () => {
          _this._log('debug','Instantiating this.delegate...','Waiting for actions to be set');
        }
        this.append(this.delegate);
        _this.hooks = {};
        _this.hooks.onPlay=function(){
          _this.delegate.classList='icon-clickable icon-stop-circle-fill';
          if('onclick' in _this.settings)
          {
            if(_this.settings.onclick=='delegate_click')
            {
              _this.delegate.style.visibility="hidden";
            }
          }
        }
         _this.hooks.onPause=function(){
          _this.delegate.classList='icon-clickable icon-play-circle-fill';
          if('onclick' in _this.settings)
          {
            if(_this.settings.onclick=='delegate_click')
            {
              _this.delegate.style.visibility="visible";
            }
          }
        }

         _this.hooks.onComplete=function(){
          _this.delegate.classList='icon-clickable icon-replay';
          if('onclick' in _this.settings)
          {
            if(_this.settings.onclick=='delegate_click')
            {
              _this.delegate.style.visibility="visible";
            }
          }
        }

        _this.hooks.onStop=function(){
          _this.delegate.classList='icon-clickable icon-play-circle-fill';
          _this.delegate.style.visibility="visible";
        }
        _this.hooks.onError = function(){
         _this.delegate.classList='icon-clickable icon-error';
         window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'message':'Sorry, cannot play video. Please try again later.','icon':'done','action':'auto_close-2000'}}));
        };

      }

      this.delegate.dblclick = async () => {
        try
        {
          if(typeof _this.video == 'object' && 'state' in _this.video)
          {
            if(_this.video.state == 'stopped' || _this.video.state == 'paused' || _this.video.state == 'none')
            {
              _this._log('debug','this.delegate.dblclick','Toggle click event...Play');
              await _this.action('play');
            }
            else
            {
              _this._log('debug','this.delegate.dblclick','Toggle click event...Stop');
              await _this.action('stop');
            }
          }
          else
          {
            throw 'Nothing to do no video setup';
          }
        }
        catch(ex)
        {
          _this._log('error','delegate.onclick',ex);
          await _this.action('reset');
          _this.hooks.onError();
        }
      };

      this.delegate.onclick = async () => {
        try
        {
          if(typeof _this.video == 'object' && 'state' in _this.video)
          {
            if(_this.video.state == 'stopped' || _this.video.state == 'paused' || _this.video.state == 'none')
            {
              _this._log('debug','this.delegate.onclick','Toggle click event...Play');
              await _this.action('play');
            }
            else
            {
              _this._log('debug','this.delegate.onclick','Toggle click event...Pause');
              await _this.action('pause');
            }
          }
          else
          {
            throw 'Nothing to do no video setup';
          }
        }
        catch(ex)
        {
          _this._log('error','delegate.onclick',ex);
          await _this.action('reset');
          _this.hooks.onError();
        }

      };

      await _this.action('isRunning');

    }
  }
}

